/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./language-resource.vue?vue&type=template&id=f7e04c56&"
import script from "./language-resource.vue?vue&type=script&lang=js&"
export * from "./language-resource.vue?vue&type=script&lang=js&"
import style0 from "./language-resource.vue?vue&type=style&index=0&id=f7e04c56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports